import React, { useEffect, useState } from "react";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import { historyEmployeeById } from "../../../api/booking/booking";
import {
  decodeRefreshToken,
  getToken,
} from "../../../helpers/token/refreshToken";
import "./style/HistoryFinal.css";

export const HistoryFinal = () => {
  const [trips, setTrips] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;

    const loadHistory = async () => {
      try {
        const token = getToken("etknre");
        if (!token) throw new Error("No se encontró la sesión del empleado");

        const employeeId = decodeRefreshToken(token);
        const response = await historyEmployeeById(employeeId);
        if (active) {
          setTrips(Object.values(response.data?.history ?? {}));
        }
      } catch (requestError) {
        if (active) setError(true);
      } finally {
        if (active) setLoading(false);
      }
    };

    loadHistory();
    return () => {
      active = false;
    };
  }, []);

  return (
    <section className="history-final" aria-labelledby="history-final-title">
      <header className="history-final__header">
        <div>
          <span className="history-final__eyebrow">HISTORIAL DE VIAJES</span>
          <h2 id="history-final-title">Viajes finalizados</h2>
        </div>
      </header>

      {loading && (
        <p className="history-final__message">Cargando historial...</p>
      )}
      {!loading && error && (
        <p className="history-final__message" role="alert">
          No se pudo cargar el historial. Inténtalo nuevamente más tarde.
        </p>
      )}
      {!loading && !error && trips.length === 0 && (
        <p className="history-final__message">
          Aún no hay viajes en el historial.
        </p>
      )}
      {!loading && !error && trips.length > 0 && (
        <div className="history-final__list">
          {trips.map((trip, index) => (
            <article
              className="history-final__card"
              key={trip.id ?? `${trip.order_number}-${index}`}
            >
              <div className="history-final__card-header">
                <div>
                  <span className="history-final__label">N.º de pedido</span>
                  <h3>#{trip.order_number ?? "—"}</h3>
                </div>
                <div className="history-final__schedule">
                  <span>
                    <CalendarMonthOutlinedIcon aria-hidden="true" />
                    <time dateTime={trip.date?.split("/").reverse().join("-")}>
                      {trip.date ?? "—"}
                    </time>
                  </span>
                  <span>
                    <AccessTimeOutlinedIcon aria-hidden="true" />
                    {trip.time ?? "—"}
                  </span>
                </div>
              </div>

              <div className="history-final__route">
                <div
                  className="history-final__route-markers"
                  aria-hidden="true"
                >
                  <span className="history-final__origin-dot" />
                  <span className="history-final__route-line" />
                  <span className="history-final__destination-dot" />
                </div>
                <div className="history-final__stops">
                  <div>
                    <span className="history-final__label">Origen</span>
                    <p>{trip.origin_name || "No disponible"}</p>
                  </div>
                  <div>
                    <span className="history-final__label">Destino</span>
                    <p>{trip.destination_name || "No disponible"}</p>
                  </div>
                </div>
              </div>

              <div className="history-final__driver">
                <span className="history-final__driver-icon">
                  <PersonOutlineOutlinedIcon aria-hidden="true" />
                </span>
                <div>
                  <span className="history-final__label">Conductor</span>
                  <p>
                    {[trip.driver_name, trip.driver_lastname]
                      .filter(Boolean)
                      .join(" ") || "Sin conductor"}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      )}
    </section>
  );
};
